import '../../assets/list.css';
import { jsx as l } from "react/jsx-runtime";
import m from "clsx";
import { forwardRef as a } from "react";
const c = "_list_nb8ny_1", n = {
  list: c
}, b = a((s, t) => {
  const { className: o, style: e, maxHeight: r = "18.75rem", ...i } = s;
  return /* @__PURE__ */ l("ul", { ...i, ref: t, style: { ...e, ...{ "--wds-combobox-content-list-max-height": r } }, className: m(n.list, o) });
});
b.displayName = "Combobox.Content.List";
export {
  b as List
};
